module.exports = __webpack_public_path__ + "img/spacial-student3.7912726b.png";